window.FormValidation = require("../../../../core/plugins/formvalidation/dist/js/FormValidation.full.min")
window.FormValidationBootstrap5 = require("../../../../core/plugins/formvalidation/dist/js/plugins/Bootstrap5")
import '../../../../custom/js/scripts/api';
const register = {
    init(){
        register.initLangSelector();
        register.initForm();
    },
    initLangSelector(){
        let lang = document.getElementById('language');
        lang.addEventListener('change', function(e) {
            window.location.href = `?lang=${e.target.value}`;
        });
    },
    initForm(){
        register.form = document.querySelector('#register_form');
        register.email_check_timeout = false;
        register.passwordMeter = new KTPasswordMeter(document.querySelector('#password_meter'));
        let submitButton = document.querySelector('#register_submit');
        let validator = FormValidation.formValidation(
            register.form,
            {
                fields: {
                    'email': {
                        validators: {
                            regexp: {
                                regexp: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                message: translations.not_valid_email,
                            },
                            notEmpty: {
                                message: translations.email_required
                            },
                            remote: {
                                message: translations.accountexists,
                                url: '/register/checkemail',
                                delay:500
                            }
                        }
                    },
                    'password': {
                        validators: {
                            notEmpty: {
                                message: translations.password_required,
                            },
                            callback: {
                                message: translations.password_required,
                                callback: function(input) {
                                    return register.validatePassword();
                                }
                            }
                        }
                    },
                    'confirm': {
                        validators: {
                            notEmpty: {
                                message: ' ',
                            },
                            identical: {
                                compare: function () {
                                    return register.form.querySelector('[name="password"]').value;
                                },
                                message: translations.password_required2,
                            },
                        },
                    },
                    'toc': {
                        validators: {
                            notEmpty: {
                                message:  translations.terms
                            }
                        }
                    },
                    'firstname': {
                        validators: {
                            notEmpty: {
                                message:  translations.firstname_required
                            }
                        }
                    },
                    'company_name': {
                        validators: {
                            notEmpty: {
                                message:  translations.lastname_required
                            }
                        }
                    },
                    'lastname': {
                        validators: {
                            notEmpty: {
                                message:  translations.company_required
                            }
                        }
                    }
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger({
                        event: {
                        }
                    }),
                    bootstrap: new FormValidationBootstrap5({
                        rowSelector: '.fv-row',
                    })
                }
            }
        );
        register.form.querySelector('[name="password"]').addEventListener('input', function () {
            validator.revalidateField('confirm');
        });
        submitButton.addEventListener('click', function (e) {
            e.preventDefault();
            validator.revalidateField('password');
            validator.validate().then(async function(status) {
                if(grecaptcha.getResponse() === ""){
                    let capt = register.form.querySelector('[title="reCAPTCHA"]')
                    capt.style.border = '1.5px solid #F1416C';
                    capt.style['border-radius'] = '5px';
                   return;
                }
                if(status === 'Valid'){
                    submitButton.setAttribute('data-kt-indicator', 'on');
                    submitButton.disabled = true;
                    let data = await API.post("/register",{
                        firstname: register.form.querySelector('[name="firstname"]').value,
                        name: register.form.querySelector('[name="company_name"]').value,
                        lastname: register.form.querySelector('[name="lastname"]').value,
                        email: register.form.querySelector('[name="email"]').value,
                        password: register.form.querySelector('[name="password"]').value,
                        password2: register.form.querySelector('[name="confirm"]').value,
                        toc: register.form.querySelector('[name="toc"]').value
                    });
                    if(data.status === 200){
                        register.form.style.display = 'none';
                        document.querySelector('#finished').style.display = 'block';
                    }
                 }
            });
        });
    },
    validatePassword() {
        return (register.passwordMeter.getScore() === 80);
    }
}
window.register = register;
